/****************************************************
 * Module Name:  lotIntimationModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import { Button } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "./../../style/modalstyle.css";
import LotIntimationMaster from "../manufacturing/operations/lotIntimationMaster";

const LotIntimationModal = ({ handleClose, show, vendorData }) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={Constants.COMPANY_LOGO}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp; Lot Master
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LotIntimationMaster vendorData={vendorData} editButton={true} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" color="error" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LotIntimationModal;
